import React from 'react';

import {ProcessTaskSchema} from 'processes/ProcessConstants';
import {RequestTaskSchema} from 'requests/tasks/RequestTaskConstants';
import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {SchemaInterface} from 'schemas/SchemaConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import ErrorMessage from 'ui-library/ErrorMessage';
import SettingsField from 'ui-library/SettingsField';

interface SchemaWarehouseNameInputProps {
  isWritable: boolean;
  sqlIdentifier?: string;
  onSqlIdentifierChange: (name: string) => void;
  schema?: AssaySchema | RequestTaskSchema | SchemaInterface | ProcessTaskSchema | null;
  error?: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function SchemaWarehouseNameInput(props: SchemaWarehouseNameInputProps): JSX.Element | null {
  return (
    <>
      <SettingsField
        isBeingCreated={props.schema == null}
        isRequired={props.schema != null}
        isWritable={props.isWritable}
        label="System name"
        name="warehouse_name"
        onChange={props.onSqlIdentifierChange}
        value={props.sqlIdentifier}
        {...getTestProps(props.dataTestAttrs)}
      />
      <ErrorMessage
        dataTestAttrs={{component: 'SchemaWarehouseNameInput', element: 'error'}}
        error={props.error ?? ''}
      />
    </>
  );
}
